module.exports = __webpack_public_path__ + "static/media/hittite_text_04.08f126ef.jpg";